import { PaginatedDataDTO } from '@bottega52/commons-pagination';
import { Card } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import {
  CategoryScale, Chart as ChartJS, Legend, LinearScale, BarElement, PointElement, Title,
  Tooltip
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import _ from 'lodash';
import * as React from "react";
import { Bar } from 'react-chartjs-2';
import { createWalletUsageChartData } from '../../../redux/credits/credits.actions';
import { IWalletUsageInDTO } from '../../../repository/jago/model/input/IWalletUsageInDTO';
import Utils from '../../../utils/Utils';
import WalletConsumptionList from './WalletConsumptionList';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const styles = createStyles({
  rowContainer: {
    display: 'flex',
    margin: 10,
    flexDirection: 'column'
  },
  rowBodyContainer: {
    padding: 15,
    minHeight: 100,
  },
  rowTitle: {
    fontWeight: 'bold'
  },
  logo: {
    width: '20%',
  },
});


export interface IWalletConsumptionPageProps extends WithStyles<typeof styles>{
  walletCreditUsages: PaginatedDataDTO<IWalletUsageInDTO> | undefined;
  onFetchMoreItems: (page: number) => void;
}

class WalletConsumptionPage extends React.Component<IWalletConsumptionPageProps, any> {

  public render() {
    const { walletCreditUsages, onFetchMoreItems } = this.props;
    const data = walletCreditUsages?.content ? createWalletUsageChartData(walletCreditUsages.content) : { labels: [], datasets: []};
    const max = walletCreditUsages?.content ? Utils.formatCreditsIn(_.maxBy(walletCreditUsages?.content, value => value.quantity)?.quantity) : 0;
    return (
      <div style={{ zIndex: 100, margin: 10 }}>
        {walletCreditUsages?.content && !_.isEmpty(walletCreditUsages.content) ? (
          <Card style={{ padding: 10 }}>
            <Bar
              data={data}
              height={250}
              options={{
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    display: false
                  },
                  datalabels: {
                    display: true,
                    color: '#3f3f3f',
                    align: 'top',
                    clamp: true,
                    offset: 5
                  }
                },
                scales: {
                  y: {
                    suggestedMax: max ? max + 100 : 0,
                  }
                }
              }}
            />
          </Card>
        ): null}
        <WalletConsumptionList
          walletUsage={walletCreditUsages}
          onFetchMoreItems={page => onFetchMoreItems(page)}
        />
      </div>
    );
  }
}

export default withStyles(styles)(WalletConsumptionPage);